/**
 * Whether a cart line is the free gift.
 *
 * The gift is added with a `_gwp` property (see `vue/store/gwp.js`), and both
 * the row and the drawer's savings figure have to agree on the rule — a row
 * labelled "Free Gift!" whose value is left out of the savings is exactly the
 * mismatch this avoids.
 */
export const isGwpLine = (item) =>
  Object.keys(item?.properties || {}).some((key) => key.includes("_gwp"));
